"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createZodTypeGuards = createZodTypeGuards;
exports.assertNodeConfig = assertNodeConfig;
const zod_1 = require("zod");
const common_1 = require("@finley-technologies/common");
const upperFirst_1 = __importDefault(require("lodash/upperFirst"));
function createZodTypeGuards(zodConfigSchema, zodNodeSchema, artifactType) {
    const isNodeConfig = (obj) => {
        const result = zodConfigSchema.safeParse(obj);
        if (!result.success) {
            (0, common_1.debugLog)(`Error validating config schema for ${artifactType}`, result.error, obj);
        }
        return result.success;
    };
    const typeGuard = (obj, customOnErrors) => {
        // use given onErrors or default to debugLog
        // strip out the db timestamps before validating.
        const updatedObj = common_1.utils.stripDbTimeStamps(obj);
        const result = zodNodeSchema.safeParse(updatedObj);
        if (!result.success) {
            const prettyError = zod_1.z.prettifyError(result.error); // This will throw if the error is not a ZodError
            const errors = [prettyError];
            if (customOnErrors) {
                customOnErrors(errors, updatedObj);
            }
            else {
                (0, common_1.debugLog)(`Error validating node schema for ${artifactType}`, errors, updatedObj);
            }
        }
        return result.success;
    };
    // Narrows on artifact.type alone; the configuration is not validated. Use it
    // only when the input is trusted, e.g. a graph read back from the DB. Use
    // typeGuard to validate the whole node.
    const hasArtifactType = (obj) => {
        return obj.type === artifactType;
    };
    return { isNodeConfig, typeGuard, hasArtifactType };
}
// Asserts `configuration` is `node`'s configuration, e.g.
// `assertNodeConfig(dbNodes.masterLoanTape, configuration)`. The error labels
// come from the node's artifactType, so they cannot drift from the guard used.
function assertNodeConfig(node, configuration, logMeta = {}) {
    (0, common_1.finleyAssert)(node.isNodeConfig(configuration), new common_1.error.TypeError({
        resourceType: `${(0, upperFirst_1.default)(node.artifactType)}Configuration`,
        typeguardName: `dbNodes.${node.artifactType}.isNodeConfig`,
        metadata: {
            logMeta: { configuration: JSON.stringify(configuration), ...logMeta },
        },
    }));
}
//# sourceMappingURL=typeguards.js.map